import { FC, memo } from 'react';

import { IconElement } from './Icon.styles';
import { IconProps } from './types';

const Icon: FC<IconProps> = ({ className, iconName, color, ...props }: IconProps) => (
	<IconElement
		aria-label={`${iconName} icon`}
		className={className}
		src={`/icons/${iconName}.svg`}
		color={color}
		{...props}
	/>
);

const memorizedIcon: FC<IconProps> = memo(Icon);

export { memorizedIcon as Icon };
